import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import type { UserRole } from '../types';
import { keys } from './keys';

type Variables = {
  memberId: string;
  userId: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  spaceId: string;
};

async function updateSpaceMember(variables: Variables) {
  const { error: memberError } = await apiClient
    .from('space_members')
    .update({ role: variables.role })
    .eq('id', variables.memberId);

  if (memberError) {
    throw memberError;
  }

  const { error: profileError } = await apiClient
    .from('profiles')
    .update({ first_name: variables.firstName, last_name: variables.lastName })
    .eq('id', variables.userId);

  if (profileError) {
    throw profileError;
  }
}

export default function useUpdateSpaceMember() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) => updateSpaceMember(variables),
    onSuccess: (_data, variables) => {
      enqueueSnackbar('Membre mis à jour.', 'success');
      queryClient.invalidateQueries({ queryKey: keys.members(variables.spaceId) });
    },
  });
}
